import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

function MentorChatIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 27 27" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ?? ''}
        d="M13.75 0C6.84626 0 1.25001 5.59625 1.25001 12.5C1.25001 14.7731 1.86626 16.8981 2.92626 18.7344L0.0737557 25.2244C-0.242494 25.9438 0.518131 26.6619 1.21813 26.3056L7.31438 23.2013C9.19626 24.3356 11.3931 25 13.75 25C20.6538 25 26.25 19.4037 26.25 12.5C26.25 5.59625 20.6538 0 13.75 0Z"
        fill={`url(#${uuid}paint0_linear)`}
      />
      <path
        className={pathClassName ?? ''}
        d="M13.4673 7.144C14.6086 7.144 15.5206 7.44267 16.2033 8.04C16.8966 8.63733 17.2433 9.48 17.2433 10.568C17.2433 11.5707 16.9126 12.3547 16.2513 12.92C15.6006 13.4747 14.7366 13.7573 13.6593 13.768L13.5793 14.968H11.1793L11.0993 11.992H12.0593C12.8806 11.992 13.5046 11.8907 13.9313 11.688C14.3686 11.4853 14.5873 11.1173 14.5873 10.584C14.5873 10.2107 14.486 9.91733 14.2833 9.704C14.0806 9.49067 13.798 9.384 13.4353 9.384C13.0513 9.384 12.7526 9.496 12.5393 9.72C12.326 9.93333 12.2193 10.2267 12.2193 10.6H9.64331C9.62198 9.94933 9.75531 9.36267 10.0433 8.84C10.342 8.31733 10.7793 7.90667 11.3553 7.608C11.942 7.29867 12.646 7.144 13.4673 7.144ZM12.4113 19.128C11.9313 19.128 11.5366 18.9893 11.2273 18.712C10.9286 18.424 10.7793 18.072 10.7793 17.656C10.7793 17.2293 10.9286 16.872 11.2273 16.584C11.5366 16.296 11.9313 16.152 12.4113 16.152C12.8806 16.152 13.2646 16.296 13.5633 16.584C13.8726 16.872 14.0273 17.2293 14.0273 17.656C14.0273 18.072 13.8726 18.424 13.5633 18.712C13.2646 18.9893 12.8806 19.128 12.4113 19.128Z"
        fill="white"
      />
      <defs className={pathClassName ?? ''}>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="20.1263"
          x2="4.96813"
          y1="1.74625"
          y2="27.3112"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#B076BF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MentorChatIcon
